export const FACEBLOCK_MODE = {
  BLUR: 'BLUR',
  WALDO_ICON: 'WALDO_ICON',
};
